import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { NzConfigService } from 'ng-zorro-antd/core/config';
import { UiNotificationHostComponent } from '@shared/components/ui-notification/ui-notification-host.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, UiNotificationHostComponent],
  template: `
    <router-outlet />
    <ui-notification-host />
  `,
})
export class AppComponent {
  constructor(
    library: FaIconLibrary,
    nzConfigService: NzConfigService
  ) {
    library.addIconPacks(far, fas, fal);
    nzConfigService.set('dropDown', { nzBackdrop: true });
  }
}
